<template>
    <div class="d-flex flex-row gap-10">
        <!-- List addresses -->
        <div v-for="address in order.addresses"
             :key="address.pivot.address_id"
             class="d-flex flex-column gap-3"
        >
            <div class="font-size-h5 text-muted">
                <i class="fas" :class="icon(address)"/>
                {{ addressType(address) }}
            </div>
            <OrderAddress :address="address"
                          :editable="canEditAddress"
                          :order="order"
            />
        </div>
        <div v-if="order.addresses.length > 0 && order.addresses[0].phone">
            <div class="font-size-h5 text-muted">
                <i class="fas fa-phone"/>
                {{ __('general.phone') }}
            </div>
            <div class="mt-3 font-weight-bold text-center">
                {{ order.addresses[0].phone }}
            </div>
        </div>

        <!-- No addresses available -->
        <p v-if="waitingForAddress">
            {{ __('orders.address.loading') }}
        </p>
        <p v-else-if="addressDeleted">
            {{ __('orders.address.deleted') }}
        </p>
    </div>
</template>

<script>
import OrderAddress from '@components/Orders/OrderAddress.vue';
import {PermissionsMixin} from '@js/permissions';
import {OrderAddressType} from "@generated/orderAddressType";

export default {
    components: {
        OrderAddress,
    },

    mixins: [PermissionsMixin],

    props: {
        order: Object,
    },

    methods: {
        addressType(address) {
            if (address.pivot.type === OrderAddressType.INVOICE) {
                return this.__('general.address.invoice');
            }
            if (address.pivot.type === OrderAddressType.DELIVERY) {
                return this.__('general.address.shipping');
            }
        },

        icon(address) {
            return address.pivot.type === OrderAddressType.INVOICE ? 'fa-file-invoice' : 'fa-truck-moving';
        },
    },

    computed: {
        canEditAddress() {
            return this.hasStorePermission(this.order.store_uuid, this.StorePermission.PROCESS_ORDERS)
        },

        isWaitingForIntegration() {
            return this.order.state === 'wait_for_integration';
        },

        isPending() {
            return this.order.state === 'pending';
        },

        isConfirmed() {
            return this.order.state === 'confirmed';
        },

        isReadyForPickup() {
            return this.order.state === 'pickup';
        },

        waitingForAddress() {
            return this.order.addresses.length === 0 &&
                (this.isPending || this.isWaitingForIntegration || this.isReadyForPickup || this.isConfirmed);
        },

        addressDeleted() {
            return this.order.addresses.length === 0 &&
                !(this.isPending || this.isWaitingForIntegration || this.isReadyForPickup || this.isConfirmed);
        },
    },
};
</script>
